interface Props {
  currentRevision: number
}

export default function ConfigRevisionHistory({ currentRevision }: Props) {
  return (
    <div style={cardStyle}>
      <div style={cardTitleStyle}>Revision History</div>
      <p style={{ fontSize: 13, color: '#888', margin: 0 }}>
        Current revision: <strong>{currentRevision}</strong>
      </p>
      <p style={{ fontSize: 12, color: '#aaa', marginTop: 8, marginBottom: 0 }}>
        Full revision history — to be supported in a future backend release.
      </p>
    </div>
  )
}

const cardStyle: React.CSSProperties = {
  background: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: 6,
  padding: '14px 16px',
}

const cardTitleStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 700,
  color: '#333',
  marginBottom: 10,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
}
